import React from "react";
import {  FaCheckCircle, FaStar, FaRocket, FaMobileAlt, FaCode } from 'react-icons/fa';
import { motion } from "framer-motion";
import { Variants, easeOut } from "framer-motion";
import webDevImg from "../../../assets/IT-services/webdev.png";
import img1 from "../../../assets/IT-services/bg.jpg"; // Example image for the first step
import { Helmet } from "react-helmet-async";
// Example image for the first step

// Animation variants for fade up effect

// const fadeZigzag = (index: number) => ({
//   hidden: { opacity: 0, x: index % 2 === 0 ? -50 : 50 },
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: {
//       duration: 0.6,
//       ease: "easeOut",
//     },
//   },
// });

const fadeZigzag = (index: number): Variants => ({
  hidden: {
    opacity: 0,
    x: index % 2 === 0 ? -50 : 50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
});

export default function WebDevelopmentPage() {
  return (
    <div className="text-white">

      <Helmet>
  <title>Web Development Services | Nadezhda Venture</title>
  <meta
    name="description"
    content="Boost your online presence with high-performance websites crafted by Nadezhda Venture. Fast, SEO-friendly, and mobile-first design tailored for your success."
  />
  <meta
    name="keywords"
    content="Web Development, Website Design, SEO-friendly Websites, Responsive Websites, Nadezhda Venture, Best IT Training in Noida"
  />
  <meta name="author" content="Nadezhda Venture" />

  {/* Open Graph Tags */}
  <meta property="og:title" content="Web Development Services | Nadezhda Venture" />
  <meta
    property="og:description"
    content="Craft high-performance websites with expert web development services from Nadezhda Venture."
  />
  <meta property="og:image" content="https://yourdomain.com/path-to-preview-image.jpg" />
  <meta property="og:url" content="https://yourdomain.com/web-development" />
  <meta property="og:type" content="website" />
</Helmet>

      {/* 🔷 Hero Section (Dark Blue) */}
      <section className="relative overflow-hidden bg-blue-950 text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center py-20 px-6 relative z-10">
          {/* Left Content */}
          <div className="md:w-1/2 z-20">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="text-4xl md:text-5xl font-bold mb-6"
            >
              Crafting <span className="text-orange-500">High-Performance</span> Websites <br />
              That Drive <span className="text-orange-500">Real Results</span>
            </motion.h1>
            <ul className="space-y-3 text-lg mb-6 text-blue-100">
              <li className="flex items-center gap-2">
                <FaCheckCircle className="text-orange-400" /> Lightning-fast load speeds
              </li>
              <li className="flex items-center gap-2">
                <FaCheckCircle className="text-orange-400" /> SEO-friendly architecture
              </li>
              <li className="flex items-center gap-2">
                <FaCheckCircle className="text-orange-400" /> Fully custom & responsive design
              </li>
            </ul>
            {/* <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full font-semibold shadow-lg transition">
              Build My Website
            </button> */}

            {/* <div className="mt-8 flex items-center gap-4 text-sm text-gray-300">
              <span>Rated 5 Stars</span>
              <div className="flex gap-1 text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
            </div> */}
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 relative mt-10 md:mt-0">
            <div className="absolute -top-[100px] -right-80 w-[150%] h-[150%] bg-orange-500 rounded-full opacity-70 -z-10" />
            <img
              src={webDevImg}
              alt="Web Development Illustration"
              className="w-[700px] mx-auto md:mx-0"
            />
          </div>
        </div>
      </section>

      {/* ⬜ Why Our Websites Convert (White Background) */}
      <section className="bg-white text-blue-950 py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold mb-10 text-center">
            Why Our Websites <span className="text-orange-500">Convert Better</span>
          </h2>
          <div className="grid md:grid-cols-3 gap-10 text-center">
            {[
              {
                icon: <FaRocket size={40} className="text-orange-500 mx-auto mb-4" />,
                title: "Speed-Optimized",
                desc: "Fast websites lead to lower bounce rates and better engagement.",
              },
              {
                icon: <FaMobileAlt size={40} className="text-orange-500 mx-auto mb-4" />,
                title: "Mobile First",
                desc: "80%+ traffic is mobile. We design mobile-first for maximum impact.",
              },
              {
                icon: <FaCode size={40} className="text-orange-500 mx-auto mb-4" />,
                title: "Clean Code",
                desc: "Maintainable, scalable and W3C-compliant code structure always.",
              },
            ].map((item, i) => (
              <div key={i} className="bg-gray-200 p-6 rounded-xl shadow hover:shadow-lg transition">
                {item.icon}
                <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-700">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

  <div className="py-20 px-6 bg-gray-100">
  <motion.h2
    className="text-3xl font-bold text-center text-orange-500 mb-12"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
  >
    Our Shopify Development Process
  </motion.h2>

  <div className="space-y-20 max-w-6xl mx-auto">
    {[
      {
        title: "1. Planning and Discovery",
        desc: "Product Discovery and Strategy: Define the project's goals and target audience. This process ensures alignment with business goals, customer needs, and operational feasibility, minimizing potential issues and delays.",
        img: "https://zrexa.com/wp-content/uploads/2021/04/ecommerce-store-management.png",
      },
      {
        title: "2. Design and Development",
        desc: "Design and Development of the Store: Utilize Shopify themes, Liquid language, and other tools to create the online store. This process ensures alignment with business goals, customer needs, and operational feasibility, minimizing potential issues and delays.",
        img: "https://freepngimg.com/save/14062-ecommerce-png-file/638x431",
      },
      {
        title: "3. Testing and Launch",
        desc: "Testing and QA of the Store: Rigorously test the store for functionality and performance. This process ensures alignment with business goals, customer needs, and operational feasibility, minimizing potential issues and delays.",
        img: "https://sherocommerce.com/wp-content/uploads/Digital-Strategy-Main-1-1.png",
      },
      {
        title: "4. Key Considerations",
        desc: "Code Editor and Version Control - Use these tools to manage code efficiently. This process ensures alignment with business goals, customer needs, and operational feasibility, minimizing potential issues and delays.",
        img: "https://ficuslot.co.in/assets/frontend/images/others/ecommerce6.png",
      },
    ].map((step, i) => (
      <motion.div
        key={i}
        className={`flex flex-col md:flex-row items-center md:items-start gap-8 ${
          i % 2 === 1 ? "md:flex-row-reverse" : ""
        }`}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeZigzag(i)}
      >
        {/* Card */}
        <div className="flex-1 bg-blue-950 p-6 rounded-lg shadow-md">
          <h4 className="text-xl font-semibold text-orange-600 mb-2">{step.title}</h4>
          <p className="text-white">{step.desc}</p>
        </div>

        {/* Image */}
        <div className="w-[10rem] h-[10rem] flex-shrink-0">
          <img
            src={step.img}
            alt={step.title}
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>
      </motion.div>
    ))}
  </div>
</div>


    {/* 🟦 Client Showcase with Transparent Background Image and Animation */}
<section
  className="relative text-blue-950 py-16 px-6 overflow-hidden min-h-[300px]"
>
      {/* Background Image */}
<img
  src={img1}
  alt="Background"
  className="absolute inset-0 w-[300vh] h-[300px] object-cover z-0"
/>

{/* Black Transparent Overlay */}
<div className="absolute inset-0 bg-black/40 z-10" />


  <motion.div
    className="relative z-10 max-w-7xl mx-auto"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
  >
    <h2 className="text-3xl font-bold mb-10 text-center text-orange-500">Some Brands We've Built For</h2>
    <div className="flex flex-wrap justify-center gap-8 items-center">
  {["EduPro", "TechNest", "MySalon", "BoltCart", "Devify"].map((client, i) => (
    <motion.div
      key={i}
      className="bg-white px-6 py-3 rounded-full text-sm font-semibold shadow-md cursor-pointer transition-transform text-blue-950"
      whileHover={{
        scale: 1.1,
        backgroundColor: "#f35f02",         // Orange background
        color: "#ffffff",                   // White text on hover
        boxShadow: "0 20px 30px rgba(243, 95, 2, 0.4)",
      }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      {client}
    </motion.div>
  ))}
</div>

  </motion.div>
</section>
    </div>
  );
}
